import axiosInstant from "../axiosInstant";

export async function submitAIConsignment(formData) {
  try {
    const res = await axiosInstant.post(
      "ai-consignment/submit",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error("AI Consignment Error:", error);

    return (
      error?.response?.data || {
        success: false,
        message:
          "Unable to submit your artwork at the moment. Please try again later.",
      }
    );
  }
}